/* Header hide-on-scroll controller. See cph-header-scroll.css for background. */
(() => {
  const header = document.querySelector('.shopify-section--header');
  if (!header || header.dataset.cphScrollHeaderReady) return;
  header.dataset.cphScrollHeaderReady = 'true';

  const HIDDEN_CLASS = 'cph-header-is-hidden';
  const HIDE_DISTANCE = 90;
  const SHOW_DISTANCE = 50;
  const JITTER_THRESHOLD = 4;
  const TOGGLE_COOLDOWN = 260;

  const topRevealPoint = () => Math.max(header.offsetHeight, 72);

  let lastScrollY = Math.max(window.scrollY, 0);
  let direction = 0;
  let distance = 0;
  let ticking = false;
  let lastToggle = 0;

  // Mirrors the theme's own x-header: the class drives the transform, while
  // --header-is-visible collapses --sticky-area-height so every sticky offset
  // (product sticky bar, product info column, thumbnails, toolbars) follows.
  const setVisible = (visible) => {
    header.classList.toggle(HIDDEN_CLASS, !visible);
    document.documentElement.style.setProperty('--header-is-visible', visible ? '1' : '0');
  };

  const showHeader = () => setVisible(true);
  const hideHeader = () => setVisible(false);

  const updateHeader = () => {
    const currentScrollY = Math.max(window.scrollY, 0);
    const delta = currentScrollY - lastScrollY;

    if (
      currentScrollY <= topRevealPoint() ||
      document.documentElement.classList.contains('cph-menu-is-open') ||
      header.contains(document.activeElement)
    ) {
      showHeader();
      direction = 0;
      distance = 0;
      lastScrollY = currentScrollY;
      ticking = false;
      return;
    }

    if (Math.abs(delta) < JITTER_THRESHOLD) {
      ticking = false;
      return;
    }

    const nextDirection = Math.sign(delta);

    if (nextDirection !== direction) {
      direction = nextDirection;
      distance = 0;
    }

    distance += Math.abs(delta);

    const now = Date.now();
    const settled = now - lastToggle >= TOGGLE_COOLDOWN;
    const isHidden = header.classList.contains(HIDDEN_CLASS);

    if (settled && direction > 0 && !isHidden && distance >= HIDE_DISTANCE) {
      // Don't hide out from under an open dropdown, same guard the theme uses.
      if (!header.querySelector('[open]')) {
        hideHeader();
        distance = 0;
        lastToggle = now;
      }
    } else if (settled && direction < 0 && isHidden && distance >= SHOW_DISTANCE) {
      showHeader();
      distance = 0;
      lastToggle = now;
    }

    lastScrollY = currentScrollY;
    ticking = false;
  };

  const requestHeaderUpdate = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateHeader);
  };

  window.addEventListener('scroll', requestHeaderUpdate, { passive: true });
  window.addEventListener('resize', requestHeaderUpdate, { passive: true });
  updateHeader();
})();
